<template>
    <div class="row">
        <div class="col-md-12 clearfix">
            <nav class="text-center">
                <ul class="pagination table-bootgrid__pagination">
                    <li @click="getItems(pagination.first_page_url)"
                        :class="{disabled: !pagination.prev_page_url}"
                        class="first">
                        <a data-page="first" class="button">&laquo;&laquo;</a>
                    </li>
                    <li @click="getItems(pagination.prev_page_url)"
                        :class="{disabled: !pagination.prev_page_url}"
                        class="prev">
                        <a data-page="prev" class="button">&laquo;</a>
                    </li>
                    <li v-for="i in navigation.range"
                        @click="getItems(pagination.path+'?page='+i)"
                        :class="{active: pagination.current_page === i}">
                        <a :data-page="i"
                           :class="{underline: pagination.current_page === i}">
                            {{i}}
                        </a>
                    </li>
                    <li @click="getItems(pagination.next_page_url)"
                        :class="{disabled: !pagination.next_page_url}"
                        class="next">
                        <a data-page="next" class="button">&raquo;</a>
                    </li>
                    <li @click="getItems(pagination.last_page_url)"
                        :class="{disabled: !pagination.next_page_url}"
                        class="last">
                        <a data-page="last" class="button">&raquo;&raquo;</a>
                    </li>
                </ul>
            </nav>
            <br>
            <footer class="text-center">
                Page {{pagination.current_page}} of {{pagination.last_page}}
            </footer>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      pagination: {
        current_page: {
          type: Number,
          required: true,
        },
        first_page_url: {
          type: String,
          required: true,
        },
        from: {
          type: Number,
          required: true,
        },
        last_page: {
          type: Number,
          required: true,
        },
        last_page_url: {
          type: String,
          required: true,
        },
        next_page_url: {
          type: String,
          required: true,
        },
        path: {
          type: String,
          required: true,
        },
        per_page: {
          type: Number,
          required: true,
        },
        prev_page_url: {
          type: String,
          required: true,
        },
        to: {
          type: Number,
          required: true,
        },
        total: {
          type: Number,
          required: true,
        },
      },
      navigation: {
        numLinks: {
          type: Number,
          required: true,
        },
      },
    },
    methods: {
      getItems: function(url) {
        if (url !== null) {
          this.$emit('pageChange', url);
        }
      },
      generatePaginationList: (currentPage, lastPage, numLinks) => {
        const list = [];
        const paginationPadding = Math.floor(numLinks / 2);
        let start = 0;
        let end = 0;

        if (currentPage < (paginationPadding + 1)) {
          // start
          start = 1;
          end = lastPage > numLinks ? numLinks : lastPage;
        } else if (lastPage - currentPage < paginationPadding) {
          // end
          start = lastPage - numLinks + 1;
          end = lastPage;
        } else {
          // middle
          start = currentPage - paginationPadding;
          end = currentPage + paginationPadding;
        }

        for (let i = start; i <= end; i++) {
          list.push(i);
        }

        return list;
      },
    },
    data() {
      return {
        range: [],
      };
    },
    watch: {
      pagination() {
        this.navigation.range = this.generatePaginationList(
            this.pagination.current_page,
            this.pagination.last_page,
            this.navigation.numLinks,
        );
      },
    },
  };
</script>

<style scoped>
    .underline {
        text-decoration: underline;
    }
</style>
